import { batch } from "react-redux";
import { AppDispatch } from "@/redux/store";
import { updateCurrentLocationUpdated, updateSpecifiedLocation } from "@/redux/slice/location/slice";
import { CurrentLocationUpdatedStatus } from "@/redux/slice/location/enums/CurrentLocationUpdatedStatus";
import { LocationSuccessHandler } from "@/redux/slice/location/types/LocationSuccessHandler";
import { LocationFailHandler } from "@/redux/slice/location/types/LocationFailHandler";
import { GEO_POSITION_OPTIONS } from "@/libs/constants/location";

export default async function locateCurrentLocation(dispatch: AppDispatch): Promise<boolean> {
  return await new Promise((resolve, reject) => {
    dispatch(updateCurrentLocationUpdated(CurrentLocationUpdatedStatus.pending));

    const currentLocationSuccessHandler: LocationSuccessHandler = ({
      latitude: currentLat,
      longitude: currentLong,
    }) => {
      batch(() => {
        dispatch(
          updateSpecifiedLocation({
            latitude: currentLat,
            longitude: currentLong,
          })
        );
        dispatch(updateCurrentLocationUpdated(CurrentLocationUpdatedStatus.success));
      });
      resolve(true);
    };

    const currentLocationFailHandler: LocationFailHandler = (err) => {
      console.error(err.message);
      dispatch(updateCurrentLocationUpdated(CurrentLocationUpdatedStatus.fail));
      reject(true);
    };

    navigator.geolocation.getCurrentPosition(
      ({ coords: { latitude, longitude } }) => {
        currentLocationSuccessHandler({ latitude, longitude });
      },
      (err) => {
        currentLocationFailHandler(err);
      },
      GEO_POSITION_OPTIONS
    );
  });
}
